<template>
  <van-collapse v-model="activeNames">
      <van-collapse-item name="1">
        <template #title>
          <div class="name">{{ safeItem.name }}</div>
          <div v-if="activeNames.length == 0" class="bewrite van-multi-ellipsis--l2" v-html="safeItem.bewrite" />
        </template>
        <template #default>
          <div style="position: relative;">
          <div class="bewrite" v-html="safeItem.bewrite" />
            <div style="position: absolute;top: 5px;right: 5px;">
              <img src="@/assets/checked.png" style="width: 120px;" />
            </div>
          </div>
        </template>
      </van-collapse-item>
    </van-collapse>
</template>

<script>
export default {
  name: 'DiscountProDesc',
  props: ['item'],
  computed: {
    safeItem () {
      return this.item || null
    }
  },
  data () {
    return {
      activeNames: ['1'],
    }
  },
}
</script>
<style lang="scss" scoped>
 .name {
    font-size: 20px;
    font-weight: 600;
  }
  .bewrite {
    font-size: 14px;
    color: #969799;
    margin: 8px 0;
  }
</style>
